import axios from 'axios';
import { baseUrl } from '../utility/enums';

export const baseAxios = axios.create({
  baseURL: baseUrl
});
